import { ITranslations } from './messages';

export const nl: ITranslations = 
{
  X: {
    OK: 'OK',
    CANCEL: 'Annuleren',
    EDIT: 'Bewerken',
    VIEW: 'Bekijken',
    YES: 'Ja',
    NO: 'Nee',
    SAVE: 'Bewaren',
    DELETE: 'Verwijderen',
    SUCCESS: 'Gelukt',
    FAILED: 'Mislukt',
    FAILED_UNKNOWN: 'Sorry, we doen even wat onderhoud. Probeer het later nog eens.',
    SETTINGS: 'Instellingen',
    ON: 'aan',
    OFF: 'uit',
    ID: 'ID',
    OR: 'of',
    YOU: 'Jij',
    YOU_P: 'Jou',
    OFWHICH: 'waarvan',
    AND: 'en',
    MORE: 'meer',
    LESS: 'minder',
    ALERT: 'Let op!',
    SAVED: 'Wijzigingen opgeslagen',
    ACTIONS: 'Acties',
    TIME: {
      ABOUT: 'ongeveer',
      DAYS: '{count, plural, one {# dag} other {# dagen}}',
      HOURS: '{count, plural, one {# uur} other {# uren}}',
      MINUTES: '{count, plural, one {# minuut} other {# minuten}}',
      SECONDS: '{count, plural, one {# seconde} other {# seconden}}',
    },
    SEARCH: {
      ITEM: 'Zoek item',
      ALL: 'Alles',
      FILTER: 'Filter op titel...',
    },
    ITEMS_PER_PAGE: 'Items/pagina',
    UNREAD: 'Ongelezen',
    UNREAD_ITEMS: '{count, plural, one {# ongelezen bericht} other {# ongelezen berichten}}',
    TOPDF: 'Opslaan als PDF',
    TODOCX: 'Opslaan als Word',
  },
  GENERAL: {
    CONFIRM: {
      TITLE: 'Bevestigen',
    },
    DELETE: {
      TITLE: 'Weet je \'t zeker?',
      FOLDER: {
        DELETE_CNF: 'Deze folder ECHT VERWIJDEREN?!',
        CNF: 'Weet je zeker dat je deze folder wil verwijderen?',
        CNF2: 'Folder {foldername} wordt permanent verwijderd.',
        CNF3: 'Alle files in de folder worden ook verwijderd!',
      },
      FILE: {
        CNF: 'Weet je zeker dat je dit bestand wil verwijderen?',
      },
      NOTICE: 'Verwijderen is permanent en kan niet worden hersteld.',
      OBJECT: {
        CNF: 'Weet je zeker dat je dit wilt verwijderen?',
        CNF2: 'Let op: alle inhoud wordt ook verwijderd!',
      },
    },
    DELETE_ITEM: {
      CONFIRM: 'Weet je zeker dat je dit wil verwijderen?',
      MODERATION: 'Je modereert content van een andere deelnemer.',
    },
    FORM: {
      REQUIRED: 'Verplicht',
      AUTOCOMPL: 'Voer tekst in of kies uit lijst',
      AUTOCOMPL_FDBCK: 'Vrije invoer niet toegestaan, selecteer uit de lijst.',
      AUTOCOMPL_NONE: 'Geen suggesties beschikbaar.',
      AUTOCOMPL_PLCH: 'Type hier...',
      NODATE: 'Geen datum bekend',
      EDITING: 'in bewerking',
      ROWS_EDITING: '{count, plural, one {# rij} other {# rijen}} in bewerking',
    },
    MARKDOWN: {
      MD_LINK: 'Lees hier over Markdown',
      MD_EXPLAINER: 'Deze tekst is geformatteerd met Markdown voor bijvoorbeeld **bold** of *italics* tekst.',
      MD_EXPLAINER_2: 'Maak een link met [linktekst](https://example.com) en een nieuwe regel met twee spaties aan het einde van een regel.',
    },
    STATUS: {
      STATUS: 'Status',
      CONCEPT: 'Concept',
      ACTIVE: 'Actief',
      PUBLISHED: 'Gepubliceerd',
      FINISHED: 'Afgerond',
      ARCHIVED: 'Gearchiveerd',
      FORMER: 'Voormalig',
    },
    SHOW_MORE: 'Toon meer',
    SHOW_LESS: 'Toon minder',
    DATES: {
      START: 'Start',
      END: 'Eind',
      DURATION: 'Duur',
    },
    IMAGE: 'Afbeelding',
    IMAGE_CONTAIN: 'Afbeelding uitzoomen',
    RELOADING: 'Herladen...',
    LOCALE: {
      LABEL: 'Taal',
      NL: 'Nederlands (nl)',
      EN: 'Engels (en)',
      PT: 'Portugees (pt)',
      SHORT: {
        NL: 'NL',
        EN: 'EN',
        PT: 'PT',
      },
    },
    AUTHOR: 'Auteur',
    EDITING_LIVE_WARNING: 'Je bewerkt live content die zichtbaar is voor het publiek. Er is geen "save" of "undo" knop — wijzigingen die je maakt, worden direct gepubliceerd.',
    IMAGE_UPLOAD_SUCCESS: 'Afbeelding succesvol geüpload.',
    IMAGE_UPLOAD_FAILED: 'Afbeelding uploaden mislukt. Probeer het later nog eens.',
    UNSAVED_IMG: 'Upload eerst de afbeelding voordat je de edit mode verlaat.',
    DELETE_IMAGE_CNF: 'Weet je zeker dat je deze afbeelding wilt verwijderen?',
    DOWNLOAD: 'Download',
    SORTING_HINT: 'Sorteer items op datum, dit wordt opgeslagen.',
    SINCE: 'sinds {date}',
  },
  NAVIGATION: {
    HOME: 'Home',
    ADMIN: 'Admin',
    ADMIN_MENU: {
      EDIT_PROJECT: 'Project wijzigen',
      NEW_PROJECT: 'Nieuw project',
      EDIT_DIALOGUE: 'Dialoog wijzigen',
      RESET_ORDER: 'Reset order',
      RESET_ORDER_BLOCKS: 'Reset block order',
      USERS: 'Gebruikers',
      PROJECTS: 'Projecten',
      SETTINGS: 'App Settings',
      SLUGS: 'Project slugs',
      DEMO_MODE: 'Demo mode',
      SHOW_IDS: 'Block id\'s',
      DEBUGPANEL: 'Debug panel',
      UPDATE_CONTENT_TYPE: 'Update content type in Blob Storage',
      MAILINGS: 'Mailings',
      MAILING: 'Nieuwe mailing',
      CREATE_MENU: 'Create menu',
    },
    SETTINGS: 'Instellingen',
    LOGOUT: 'Uitloggen',
    LOGIN: 'Inloggen',
    SIGNUP: 'Registreren',
    MY_PROFILE: 'Mijn profiel',
    OVERVIEW: 'Overzicht',
    THIS_DIALOGUE: 'Deze dialoog',
    ABOUT: 'Over ons',
    HELP: {
      HELP: 'Help',
      GENERAL: 'Hulp bij dialogen',
      TOOLS: 'Hulp bij gereedschappen',
      PRIVACY: 'Jouw privacy',
      CONSENT: 'Jouw toestemming',
      WELCOME: 'Terug naar de home pagina',
    },
    ERROR_404: {
      TITLE: 'Oh, we zijn in de war...',
      TEXT1: 'Die pagina waar je om vraagt...',
      TEXT2: 'Kunnen we niet vinden.',
      BACK: 'Ga naar de vorige pagina,',
      HOME: 'of naar de home pagina.',
    },
    ERROR_CONNECTION: {
      TITLE: 'Ojee, de verbinding is weg.',
      LEVEL1: 'We proberen het te herstellen, wacht even...',
      LEVEL2: 'En we konden het niet herstellen. Controleer je netwerkverbinding en',
      RELOAD: 'herlaad de pagina.',
    },
    FOR_EVERYONE: 'Voor iedereen',
    MODERATION: 'Moderatie',
    LOADER: {
      DIALOGUE: 'Dialoog wordt geladen...',
      PROJECTS: 'Projecten worden geladen...',
      APPLICATION: 'Applicatie wordt geïnitialiseerd...',
      UNAVAILABLE: 'We kunnen Civic Technology niet bereiken...\nIs uw internetverbinding actief?',
      MAINTENANCE: 'We voeren wat onderhoud uit aan de servers...\nExcuses voor het ongemak, probeer het later nog eens.',
    },
    RESTRICTED: 'Log in om deze pagina te bekijken',
  },
  ADMIN: {
    SETTINGS: {
      FORM_TITLE: 'Settings for the entire platform',
      USERS: {
        RIGHTS: 'User rights',
      },
      MODERATORS: {
        TOOLS: 'Tools',
        TOOLS_AVAILABLE: 'Tools available to moderators',
        LISTTYPES: 'List types',
      },
      MAXMBS: {
        UPLOADS: 'Uploads',
        TITLE: 'Maximum upload sizes in MB\'s',
        IMG: 'Images',
        DOC: 'Word docs',
        XLS: 'Excel docs',
        PPT: 'Powerpoints',
        PDF: 'PDF\'s',
        DEFAULT: 'Using default ({default} MB)',
      },
      CONFIG: {
        TITLE: 'Configuration',
        ASYNC_PINGS: 'Enable async pings',
        NOTIFICATIONS_ENABLED: 'Enable notifications',
        DEBUG_PANEL: 'Show debug panel (this window only)',
        MAINTENANCE_MODE: 'Maintenance mode - currently {mode}',
      },
    },
    MAINTENANCE_MODE: {
      AUTH_REQUIRED: 'Administrator access only.',
      UNAUTHORIZED: 'You are not authorized to perform this action.',
      FORBIDDEN: 'You do not have permission to perform this action.',
      TITLE: 'Maintenance Mode',
      STATUS: 'Current Status',
      DISABLED: 'Disabled',
      ENABLED: 'Enabled',
      TOGGLE_LABEL: 'Enable Maintenance Mode',
      INFO: 'When maintenance mode is enabled, regular users will see a maintenance screen and cannot access the application. Administrators can still access the admin maintenance page to disable maintenance mode.',
    },
    USERS: {
      FORM_TITLE: 'User administration',
      SEARCH_PLCH: 'Search users by name or email',
      UNSUBSCRIBE: 'Unsubscribe',
    },
    DEBUG_PANEL: {
      SETTINGS: 'Instellingen',
      REDUX_STATE: 'Redux State',
      PROPS: 'Props',
      DEBUG: 'Debug',
      DRAG_PREVIEW: 'Drag preview',
      RELOAD: 'Refresh Redux state',
      TOGGLE_FULL_STATE: 'Toggle between curated and full state',
    },
    SITE_CONFIG: {
      TITLE: 'Site configuratie',
      TAB_MENUS: 'Menu\'s',
      TAB_PAGES: 'Pagina\'s',
      TAB_STYLING: 'Styling',
    }
  },
  FILES: {
    EDIT: 'Wijzig beschrijving',
    DESCRIPTION_DIALOGUE: 'Omschrijving bestand/link',
    DESCRIPTION_PROJECT: 'Omschrijving project-bestand',
    DESCRIPTION: 'Omschrijving',
    UPLOAD: {
      TOO_LARGE: 'Bestand is te groot: maximum grootte is {sizeallowed} MB.',
      WRONG_TYPE: 'Upload een bestand van het type: {typesallowed}.',
    },
    NO_FILE: 'Klik op de + om een bestand te kiezen, of geef een web link in de beschrijving.',
    NO_DESCRIPTION: 'Geef een naam of korte beschrijving.',
    COPY_PATH: 'Kopieer pad',
  },
  MENUS: {
    MENUS: 'Menu\'s',
    NEW_MENU: 'Nieuw menu',
    EDIT: 'Bewerk menu',
    EDIT_MENU: 'Bewerk menu {menu}',
    NONE: 'Er zijn nog geen menu\'s.',
    FORM: {
      NEW: 'Maak een nieuw menu',
      TITLE_LABEL: 'Titel',
      TITLE_PLCH: 'Titel van het menu',
      CONFLICT: 'Er bestaat al een menu met deze titel. Kies een andere titel.',
      MAINMENU: 'Gebruik \'MainMenu\' om dit menu in de hoofd navigatiebalk weer te geven.',
    },
    DELETE_CONFIRM: 'Weet je zeker dat je het menu `{menu}` wilt verwijderen?',
    DELETE_CONFIRM_2: 'Alle menu-items in dit menu worden ook verwijderd!',
    ITEMS: {
      NEW: 'Nieuw menu-item',
      NEW_IN_MENU: 'Nieuw menu-item in {menu}',
      EDIT: 'Bewerk menu-item',
      EDIT_IN_MENU: 'Bewerk menu-item in {menu}',
      TITLE_LABEL: 'Titel',
      TITLE_PLCH: 'Titel van het menu-item',
      SLUG_LABEL: 'Slug',
      SLUG_PLCH: 'Slug van het menu-item (bijv. /over-ons)',
      TEXT_LABEL: 'Tekst',
      TEXT_PLCH: 'Hint tekst voor het menu-item (optioneel)',
      CONFLICT: 'Er bestaat al een menu-item met deze titel in dit menu. Kies een andere titel.',
      DELETE_CONFIRM: 'Weet je zeker dat je het menu-item `{item}` wilt verwijderen?'
    }
  },
  PAGES: {
    PAGES: 'Pagina\'s',
    NONE: 'Er zijn nog geen pagina\'s.',
    NEW_PAGE: 'Nieuwe pagina',
    EDIT_MODE: 'Bewerken',
    SORT_MODE: 'Sorteren',
    PREVIEW_MODE: 'Bekijken',
    FORM: {
      NEW: 'Maak een nieuwe pagina',
      TITLE_LABEL: 'Titel',
      TITLE_PLCH: 'Titel van de pagina',
      SLUG_LABEL: 'Slug',
      SLUG_PLCH: 'Slug van de pagina (bijv. over-ons)',
    },
    EDIT: 'Bewerk pagina',
    DELETE_CONFIRM: 'Weet je zeker dat je de pagina `{page}` wilt verwijderen?',
    DELETE_CONFIRM_2: 'Alle content op deze pagina wordt ook verwijderd!',
    SECTIONS: {
      COUNT: '{count, plural, one {# sectie} other {# secties}}',
      DELETE_CONFIRM: 'Weet je zeker dat je deze sectie wilt verwijderen?',
      DELETE_CONFIRM_2: 'Alle content in deze sectie wordt ook verwijderd!',
    },
    ADD_SECTION: 'Sectie toevoegen',
    REMOVE_SECTION: 'Sectie verwijderen',
  },
  PROJECTS: {
    PROJECTS: 'Projecten bij Civic Technology',
    NONE: 'Er zijn nog geen projecten.',
    ADD_PROJECT: 'Project toevoegen',
    REMOVE_PROJECT: 'Project verwijderen',
    DELETE_CONFIRM: 'Weet je zeker dat je dit project wilt verwijderen?',
    DELETE_CONFIRM_2: 'Alle content in dit project wordt ook verwijderd!',
    TITLE_EN_PLCH: 'Projecttitel (Engels)',
    TITLE_NL_PLCH: 'Projecttitel (Nederlands)',
    TEXT_EN_PLCH: 'Omschrijving van het project (Engels)',
    TEXT_NL_PLCH: 'Omschrijving van het project (Nederlands)',
    PUBLICATIONS: 'Publicaties in dit project',
  },
  PUBLICATIONS: {
    PUBLICATIONS: 'Publicaties bij Civic Technology',
    NONE: 'Er zijn nog geen publicaties.',
    ADD_PUBLICATION: 'Publicatie toevoegen',
    REMOVE_PUBLICATION: 'Publicatie verwijderen',
    DELETE_CONFIRM: 'Weet je zeker dat je deze publicatie wilt verwijderen?',
    DELETE_CONFIRM_2: 'Alle content in deze publicatie wordt ook verwijderd!',
    TITLE_PLCH: 'Titel',
    TEXT_PLCH: 'Citatie tekst voor de publicatie',
    PUBLICATION_DATE: 'Publicatiedatum',
    SORT_BY_DATE: 'Sorteer op datum',
    SELECT: 'Selecteer publicaties',
  },
  TEAM: {
    MEMBERS: 'Het Civic Tech onderzoeksteam',
    NONE: 'Er zijn nog geen teamleden.',
    ADD_MEMBER: 'Teamlid toevoegen',
    REMOVE_MEMBER: 'Teamlid verwijderen',
    DELETE_CONFIRM: 'Weet je zeker dat je dit teamlid wilt verwijderen?',
    DELETE_CONFIRM_2: 'Alle informatie van dit teamlid wordt ook verwijderd!',
    SORT_BY_TIME: 'Sorteer op start datum',
    SORT_BY_NAME: 'Sorteer op naam',
    PUBLICATIONS: 'Geselecteerde publicaties',
  },
  LIBRARY: {
    LIBRARY: 'Bibliotheek',
    UPLOAD: {
      DOCUMENT: 'Upload document',
      IMAGE: 'Upload afbeelding',
      VIDEO: 'Maak video bericht',
      AUDIO: 'Maak audio bericht',
      SUBMIT: 'Versturen',
    },
    FOLDERS: {
      CREATE: 'Nieuwe folder',
      NAME: 'Foldernaam',
      REQUIRED: 'Een foldernaam is verplicht.',
      CONFLICT: 'Een folder met die naam bestaat al.',
      INVALID: 'Deze foldernaam bevat ongeldige tekens.',
      SUCCESS: 'Folder aangemaakt!',
      EDIT: 'Wijzig naam',
      REQUIRESCONVERSION: 'De bibliotheek moet aangepast worden door een moderator.',
      NO_ROOT_FOLDER: 'Er is geen root folder gevonden. Meld dit bij de admin.',
    },
    SUMMARY: {
      SUMMARY: 'Samenvatting',
      GENERATE: 'Genereer samenvatting',
      GENERATING: 'Samenvatting wordt gegenereerd...',
      EDIT: 'Wijzig samenvatting',
      DISCLAIMER: 'Let op: deze samenvatting is gegenereerd met behulp van AI en kan fouten of incorrecte informatie bevatten. Lees het originele document voor nauwkeurige informatie.',
      UNSUPPORTED: 'Samenvatting niet gegenereerd, dit bestandstype wordt niet ondersteund.',
      TOOLARGE: 'Samenvatting niet gegenereerd, dit document is te groot voor ons, sorry!',
      NO_INPUT: 'Samenvatting niet gegenereerd, dit document heeft geen tekst inhoud. Mogelijk bevat het alleen afbeeldingen.',
      UNAVAILABLE: 'Sorry, er is momenteel geen samenvatting beschikbaar.',
      PARTIAL_WARNING: 'Waarschuwing: het document is niet geheel samengevat. We hebben {percentage}% verwerkt.',
      GENERATED: 'AI versie',
      EDITED: 'Jouw versie',
      SAVE_EDITED: 'Bewaar jouw versie',
      KEEP_AI: 'Houd AI versie',
      DELETE: 'Verwijder samenvatting',
      DELETE_YOUR: 'Wil je de samenvatting die je hebt geëdit definitief verwijderen?',
      DELETE_AI: 'Wil je de AI-gegenereerde samenvatting definitief verwijderen?',
      COMPLEXITY: {
        LABEL: 'Gewenste taalniveau',
        ORIGINAL: 'Als het origineel',
        MODERATE: 'Gemiddeld',
        SIMPLE: 'Eenvoudig',
      },
      LENGTH: {
        LABEL: 'Gewenste lengte',
        SHORT: '3-4 zinnen',
        MEDIUM: '2 alinea\'s',
        LONG: '4-5 alinea\'s',
      },
    },
  },
  DOCUMENT: {
    FORM: {
      NEW: 'Creëer een nieuwe document',
      TITLE_PLCH: 'Titel van het document',
      READONLY: 'Read-only voor deelnemers',
    },
    SEE_ANNEX: 'Zie bijlage',
  },
  USERS: {
    ROLES: {
      ADMIN: 'Admin',
      ADMINS: 'Admins',
      MANAGER: 'Beheerder',
      MANAGERS: 'Beheerders',
      MODERATOR: 'Moderator',
      MODERATORS: 'Moderatoren',
      PARTICIPANT: 'Deelnemer',
      PARTICIPANTS: 'Deelnemers',
      GUEST: 'Gast',
      GUESTS: 'Gasten',
      YOU_ARE_MODERATOR: 'Jij bent moderator',
      MAKE_MODERATOR: 'Maak moderator',
    },
    FORM: {
      TITLE: 'Administratie van gebruikers',
      USER_COUNT: '{count, plural, one {# Gebruiker} other {# Gebruikers}}',
      PURGE_INACTIVE: 'Verwijder {purge} van {count} inactieve gasten',
      PURGE_INACTIVE_CNF: 'Weet je zeker dat je {purge, plural, one {# inactieve gast} other {# inactieve gasten}} wil verwijderen?',
      PURGE_INACTIVE_SUCCESS: '{purge, plural, one {# inactieve gast} other {# inactieve gasten}} verwijderd.',
      USER_SETTINGS: 'Instellingen',
      VERIFIED: 'Geverifieerd',
      ADD_USER: 'Nieuwe gebruiker',
      DELETE_USER: 'Verwijder gebruiker',
      DELETE_USER_CONF: 'Weet je zeker dat deze gebruiker verwijderd moet worden?',
      DELETE_USER_CONF_2: 'Alle informatie van deze gebruiker wordt vernietigd en kan niet worden hersteld!',
      NAME: 'Naam',
      EMAIL: 'Email',
      ROLE: 'Rol',
      LAST_LOGIN: 'Laatste login',
      SORT: {
        SORT: 'Sort users ',
        ID: 'Sort by ID',
        NAME: 'Sort by Name',
        EMAIL: 'Sort by Email',
        ROLE: 'Sort by Role',
        LAST_LOGIN: 'Sort by Last login',
        ASC: 'ascending',
        DESC: 'descending',
      },
      SUBSCRIPTIONS: 'Deelname',
      ACTIVITY: {
        MESSAGES: 'Berichten',
        VOTES: 'Stemmen & Likes',
        FILES: 'Bestanden',
      },
      PROJECTS: 'Projecten',
      PROJECT: 'Project',
      NO_PROJECTS: 'Geen projecten',
      ADD_PROJECT: 'Project toevoegen',
      DIALOGUES: 'Dialogen',
      DIALOGUE: 'Dialoog',
      NO_DIALOGUES: 'Geen dialogen',
      ADD_DIALOGUE: 'Dialoog toevoegen',
      MODERATOR: 'Moderator',
      MISSING_PROJECTS: 'Missende project-id\'s',
      MISSING_DIALOGUES: 'Missende dialoog-id\'s',
    },
    CONSENT: {
      CONSENT: 'Ik ben 18 jaar of ouder en ga akkoord met de',
      CONSENT_READ: 'Lees de',
      CONSENT_LINK: 'voorwaarden van Civic Technology',
    },
    SIGNUP: {
      FORM_TITLE: 'Welkom bij Civic Technology!',
      FORM_TITLE_COMPACT: 'Maak een account voor Civic Technology!',
      NAME: 'Je naam',
      NAME_INSTR: 'Bij Civic Technology delen we onze namen met elkaar.',
      NAME_HINT: 'Gebruik tenminste 4 letters. Je naam wordt zichtbaar voor andere gebruikers.',
      NAME_FDBCK: 'Voer tenminste 4 tekens in. Je kunt letters, streepjes en spaties gebruiken, maar geen cijfers of andere tekens en geen spaties aan begin of einde.',
      EMAIL_IN_USE: 'Dit emailadres is al in gebruik. Probeer in te loggen.',
      WELCOME: 'Welkom',
      WELCOME_NAMED: 'Dag {name}',
      USER_INSTR: 'Jouw gegevens',
      EMAIL_INSTR: 'Het email adres waarmee je inlogt.',
      EMAIL_HINT: 'We delen dit met niemand.',
      EMAIL_HINT2: 'We delen dit met niemand. Als je wil, kunnen we je mailen als er nieuwe berichten zijn. Stel dit in je profiel in.',
      EMAIL_FDBCK: 'Geef een geldig email adres.',
      PASSWORD_INSTR: 'Kies een wachtwoord',
      PASSWORD_HINT: 'Minimaal 8 karakters, tenminste een kleine letter, een hoofdletter en een cijfer.',
      PASSWORD_FDBCK: 'Controleer de regels hierboven voor een geldig wachtwoord.',
      SUBMIT_INSTR: 'Bijna klaar...',
      SUBMIT: 'Account aanmaken',
      SUBMIT_CODE: 'Bevestig account',
      HAVE_ACCOUNT: 'Heb je al een account? Dan kun je hier inloggen.',
      FAILED: 'Er is een fout opgetreden bij het inschrijven. Heb je misschien al eerder geregistreerd en het wachtwoord vergeten? Probeer het anders nog eens.',
      CODE: 'Bevestigingscode',
      CODE_HINT: 'Check je email! Daar vind de code. Controleer ook je spam folder.',
      CODE_INSTR: 'We hebben je een code gestuurd per email. Vul die hierboven in om je registratie te voltooien.',
      CODE_PLCH: 'voer de code in',
      CODE_FAILED: 'De code is niet correct. Controleer of je de juiste code uit de mail hebt ingevuld.',
      CODE_SUCCESS: 'Code geaccepteerd. Je registratie is voltooid.',
      REGCODE: 'Registratiecode',
      REGCODE_INSTR: 'Heb je een registratiecode?',
      REGCODE_PLCH: 'voer de code in',
      WITH_REGCODE: 'Ja',
      REGCODE_FDBCK: 'Vul de registratiecode in die je hebt ontvangen.',
      WITHOUT_REGCODE: 'Nee',
      SUCCESS: 'Registratie gelukt. Je kunt nu inloggen.',
      SUCCESS_GUEST: 'Registratie als gast gelukt. Je kunt nu deelnemen.',
      SUCCESS_VER: 'Registratie gelukt. Lees je email, we hebben instructies verstuurd voor de volgende stap.',
      SUCCESS_VER_REGCODE_LIST: 'Registratie gelukt. Lees je email, we hebben instructies verstuurd voor de volgende stap. Deze registratiecodes bestaan niet:',
      FAILED_CODE: 'Deze registratiecode is niet correct. Controleer of de code correct is ingevuld.',
      PROJECT: {
        WELCOME_NAMED: 'Welkom bij het project {projectName}.',
        INSTR: 'Je bent uitgenodigd om deel te nemen aan deze dialoog!',
        INSTR2: 'Volg de stappen hieronder om mee te doen.',
        HOW: 'Hoe wil je deelnemen?',
        TAB_ACCOUNT: 'Ik maak een account',
        TAB_ACCOUNT2: 'Met een account kun je later terugkomen om nog eens mee te praten.',
        TAB_GUEST2: 'Als gast doe je eenmalig mee, zonder een account.',
        TAB_GUEST: 'Ik doe mee als gast',
        TAB_HAVE_ACCOUNT: 'Ik heb al een account',
        TAB_HAVE_ACCOUNT2: 'Log in met je email en wachtwoord.',
        LOGGED_IN: 'Welkom {name}! Je bent ingelogd en kunt nu deelnemen aan de dialoog.',
        SELECT_DIALOGUE: 'Selecteer de dialoog waaraan je wilt deelnemen',
        SELECT_DIALOGUE_PLCH: 'Selecteer dialoog',
        CODE: 'Geef de toegangscode die je hebt ontvangen',
        CODE_PLCH: 'toegangscode',
      },
    },
    GUESTS: {
      FORM_TITLE_COMPACT: 'Doe mee als gast bij Civic Technology!',
      INSTR: 'Hoe wil je deelnemen?',
      GUEST: 'Eenmalig, als gast',
      USER: 'Met een account, zodat ik later kan terugkomen',
      MAKE_ACCOUNT: 'Als gast doe je eenmalig mee, zonder een account. Als je later nog wil terugkomen naar deze dialoog,',
      MAKE_ACCOUNT_LINK: 'maak dan nu een account.',
      SUBMIT: 'Registreer als gast',
      EDIT: 'Maak een account',
      UPGRADED: 'We hebben een email gestuurd om je adres te bevestigen.',
      GIVE_NAME: 'Geef me een naam',
    },
    CONFIRM: {
      TITLE: 'Email bevestiging',
      TEXT: 'Je emailadres wordt gecontroleerd...',
      SUCCESS: 'Bevestiging gelukt, je kunt nu inloggen.',
      FAILED: 'Bevestiging niet gelukt, controleer de link in je email.',
    },
    LOGIN: {
      FORM_TITLE: 'Welkom terug!',
      EMAIL: 'Je email adres',
      EMAIL_FDBCK: 'Geef een geldig email adres.',
      PASSWORD: 'Wachtwoord',
      PASSWORD_FDBCK: 'Type het wachtwoord dat je koos bij het inschrijven.',
      SUBMIT: 'Inloggen',
      OTHER_OPTIONS: 'Of ... ',
      FORGOT: 'Heb je je wachtwoord vergeten?',
      NO_ACCOUNT: 'Ben je hier nieuw?',
      NEW_USER: 'Ik heb nog geen account',
      UNVERIFIED: 'Je email-adres is nog niet bevestigd. Heb je de email gezien die we je daarover stuurden?',
      FAILED: 'Inloggen is mislukt. Zijn je email-adres en wachtwoord correct?',
      LOCKED: 'Je account is tijdelijk geblokkeerd. Probeer het later nog eens.',
    },
    FORGOT: {
      FORM_TITLE: 'Als je het wachtwoord vergeten hebt...',
      FORM_TEXT: 'We sturen je per email een link waarmee je een nieuw wachtwoord kunt instellen.',
      SUBMIT: 'Stuur link',
      TRY_AGAIN: 'Nog eens proberen in te loggen?',
      SUCCESS: 'Als je email adres bij ons geregistreerd is, dan zijn instructies nu verzonden naar je adres.',
    },
    RESET: {
      FORM_TITLE: 'Nieuw wachtwoord instellen',
      PASSWORD: 'Kies een nieuw wachtwoord',
      PASSWORD2: 'Hetzelfde wachtwoord nogmaals',
      SUBMIT: 'Bevestig nieuw wachtwoord',
      SUCCESS: 'Je nieuwe wachtwoord is opgeslagen en je kunt nu inloggen.',
      NOMATCH: 'De wachtwoorden zijn niet hetzelfde. Type tweemaal hetzelfde wachtwoord.',
      FAILED: 'Je wachtwoord kon niet worden opgeslagen. Probeer het nog eens.',
      REMEMBERED: 'Je oude wachtwoord nog eens proberen?',
    },
    PROFILE: {
      TABS: {
        PROFILE: 'Profiel',
        NOTIFICATIONS: 'Meldingen',
        LANGUAGE: 'Taal',
        LOGIN: 'Inlog-gegevens',
      },
      NAME: 'Naam',
      NAME_PLCH: 'Volledige naam en titels',
      FIRSTNAME_PLCH: 'Voornaam',
      FUNCTION_PLCH: 'Functie',
      LINKEDIN_PLCH: 'LinkedIn url',
      LINKEDIN: 'LinkedIn profiel',
      ORCID_PLCH: 'ORCID url',
      ORCID: 'ORCID',
      EMAIL: 'E-mail',
      EMAIL_INSTR: 'Je email adres wordt niet zichtbaar voor anderen.',
      EMAIL_PLCH: 'you@example.com',
      ABOUT_INSTR: 'Deel iets over jezelf zodat anderen je beter leren kennen.',
      ABOUT_PLCH: 'Schrijf iets over jezelf...',
      RESETPWD_INSTR: 'Wil je je wachtwoord wijzigen?',
      RESETPWD: 'Ja, stuur me instructies voor een nieuw wachtwoord',
      DELETE_AVATAR_CNF: 'Bevestig het verwijderen van je profielfoto',
    },
    NOTIFICATIONS: {
      TITLE: 'Email meldingen',
      ENABLE: 'Ik wil per email meldingen ontvangen over nieuws in mijn dialogen.',
      INSTR: 'Selecteer wanneer je de emails wilt ontvangen:',
      EVERYDAY: 'Dagelijks',
      PARTOFDAY: {
        MOR: 'Ochtend',
        AFT: 'Middag',
        EVE: 'Avond',
      },
      NO_DAYS_OR_HOURS: 'Kies dagen en tijden voor meldingen, anders worden ze niet verzonden.',
      IN_SPAM: 'Controleer je spam folder als je geen meldingen ontvangt.',
      MODIFY: 'Wijzig gebruikersmeldingen',
    },
    LOCALE: {
      LANGUAGE: 'Taal',
      LANGUAGE_INSTR: 'De taal voor het menu en de knoppen van deze website.',
      TRANSLATION_NO: 'Projecten en dialogen worden niet vertaald.',
      TRANSLATION_INSTR: 'Dit is ook de taal waarin dialogen voor je worden vertaald.',
      NO_TRANSLATION: 'Talen die je begrijpt',
      NO_TRANSLATION_INSTR: 'Talen die je hier selecteert worden niet vertaald.',
    },
    REGCODE: {
      FORM_TITLE: 'Registratiecode toevoegen',
      INSTR: 'Heb je een registratiecode ontvangen voor een project of dialoog? Die kun je hier invoeren.',
      SUBMIT: 'Code registreren',
      SUCCESS: 'Registratiecode is verwerkt, je kunt nu deelnemen!',
      FAILED: 'Registratiecode is niet geaccepteerd, corrigeer de code en probeer het opnieuw.',
    },
    ANONYMOUS: {
      IDENTIFIER: 'Anoniem',
      LETTER_FROM: '1',
      NAMES: 'Anonieme Roos, Anonieme Tulp, Anonieme Lelie, Anonieme Madeliefje, Anonieme Zonnebloem, Anonieme Orchidee, Anonieme Narcis, Anonieme Goudsbloem, Anonieme Chrysant, Anonieme Iris, Anonieme Pioenroos, Anonieme Lavendel, Anonieme Klaproos, Anonieme Hibiscus, Anonieme Viooltje, Anonieme Gardenia, Anonieme Magnolia, Anonieme Jasmijn, Anonieme Hortensia, Anonieme Geranium, Anonieme Begonia, Anonieme Petunia, Anonieme Azalea, Anonieme Sering, Anonieme Anemoon, Anonieme Zinnia, Anonieme Camellia, Anonieme Leeuwenbek, Anonieme Gladiool, Anonieme Basilicum, Anonieme Rozemarijn, Anonieme Tijm, Anonieme Munt, Anonieme Oregano, Anonieme Salie, Anonieme Peterselie, Anonieme Koriander, Anonieme Dille, Anonieme Bieslook, Anonieme Eucalyptus, Anonieme Esdoorn, Anonieme Eik, Anonieme Pijnboom, Anonieme Berk, Anonieme Wilg, Anonieme Ceder, Anonieme Spar, Anonieme Den, Anonieme Redwood, Anonieme Cipres, Anonieme Hulst, Anonieme Magnolia, Anonieme Kornoelje, Anonieme Es, Anonieme Beuk, Anonieme Iep, Anonieme Kers, Anonieme Appel, Anonieme Banaan, Anonieme Sinaasappel, Anonieme Mango, Anonieme Aardbei, Anonieme Blauwe bes, Anonieme Framboos, Anonieme Kers, Anonieme Druif, Anonieme Ananas, Anonieme Watermeloen, Anonieme Perzik, Anonieme Pruim, Anonieme Kiwi, Anonieme Papaja, Anonieme Peer, Anonieme Granaatappel, Anonieme Citroen, Anonieme Limoen, Anonieme Kokosnoot, Anonieme Wortel, Anonieme Tomaat, Anonieme Sla, Anonieme Broccoli, Anonieme Komkommer, Anonieme Paprika, Anonieme Spinazie, Anonieme Courgette, Anonieme Aubergine, Anonieme Pompoen, Anonieme Rhododendron, Anonieme Azalea, Anonieme Palm, Anonieme Forsythia, Anonieme Hortensia, Anonieme Jeneverbes, Anonieme Liguster, Anonieme Sneeuwbal, Anonieme Spirea, Anonieme Hazel, Anonieme Klimop, Anonieme Bosrank, Anonieme Blauwe regen, Anonieme Bougainvillea, Anonieme Kamperfoelie, Anonieme Passiebloem, Anonieme Erwt, Anonieme Bamboe, Anonieme Gras, Anonieme Zoysia, Anonieme Switchgrass, Anonieme Miscanthus, Anonieme Aloë Vera, Anonieme Jadeplant, Anonieme Echeveria, Anonieme Agave, Anonieme Vetkruid, Anonieme Haworthia, Anonieme Kalanchoë, Anonieme Aeonium, Anonieme Sempervivum, Anonieme Crassula',
    },
  },
};

export default nl;
